export default __webpack_public_path__ + "static/media/www.d6cd01f5.png";